<div class="flex-row header-wrapper">
  <h3>About Us</h3>
  <button mat-icon-button aria-label="close dialog" mat-dialog-close class="button-close">
    <mat-icon>close</mat-icon>
  </button>
</div>
<mat-dialog-content class="main-text-font body-font aboutUs-Content">
  <div class="content-wrapper">
    <address>
      <strong>DPC DATA Inc.</strong><br>
      103 Eisenhower Parkway, Suite 302<br>
      Roseland, NJ 07068<br>
    </address>
    <p>
    <div class="flex-row">
      <div class="aboutUs-contactLabel">Tel:</div>
      <div class="aboutUs-contact">800.996.4747 / 201.346.0701</div>
    </div>
    <div class="flex-row">
      <div class="aboutUs-contactLabel">Fax:</div>
      <div class="aboutUs-contact">201.346.0720</div>
    </div>
    <div class="flex-row">
      <div class="aboutUs-contactLabel">Web:</div>
      <div class="aboutUs-contact"><a target="_blank" href="http://www.dpcdata.com">www.dpcdata.com</a></div>
    </div>
    <div class="flex-column">
      <div class="flex-row">
        <div class="name-column">Michael Walsh, SVP, Head of Sales</div>
        <div class="phone-column">201.346.0701 (ext. 109)</div>
        <div><a class="email" href="mailto:mwalsh@dpcdata.com">mwalsh&#64;dpcdata.com</a></div>
      </div>
      <div class="flex-row">
        <div class="name-column">George Adjami, VP - Sales</div>
        <div class="phone-column">201.346.0701 (ext. 133)</div>
        <div><a class="email" href="mailto:gadjami@dpcdata.com">gadjami&#64;dpcdata.com</a></div>
      </div>
      <div class="flex-row">
        <div class="name-column">James Kelly, VP - Sales</div>
        <div class="phone-column">201.346.0701 (ext. 145)</div>
        <div><a class="email" href="mailto:jkelly@dpcdata.com">jkelly&#64;dpcdata.com</a></div>
      </div>
      <div class="flex-row">
        <div class="name-column">General inquiries</div>
        <div class="phone-column"></div>
        <div><a class="email" href="mailto:sales@dpcdata.com">sales&#64;dpcdata.com</a></div>
      </div>
    </div>
    <p>
      <br/>
    </p>
    <p>
      <strong>DPC DATA, Inc.</strong> is a financial information services company headquartered in Roseland, NJ,
      specializing in municipal
      bond disclosure data and related services. For more than 20 years, our content and solutions have promoted
      transparency while enabling municipal market participants to fulfill their regulatory and compliance obligations
      via
      our integrated workflow services.
    </p>

    <p>
      DPC DATA offers the following branded products and services:
    </p>

    <p>
      <strong><i>Muni</i>POINTS&reg;</strong> is a sales and compliance solution that helps firms comply with MSRB
      Rules G-17, G-19, G-30 and G-47.
      <i>Muni</i>POINTS offers concise, bulleted-pointed information sheets, containing descriptive information taken
      directly
      from the official statement.
    </p>

    <p>
      <strong><i>Muni</i>DOCS&reg;</strong> Online provides all the related primary and secondary market disclosure
      data that has been
      officially
      filed for the bond issue, including:
    </p>

    <ul>
      <li>The official statement as well as any amendments or advance refunding documents</li>
      <li>Material event notices</li>
      <li>Financial statements and continuing disclosures for the obligor</li>
    </ul>

    <p>
      <strong><i>Muni</i>GUARD Monitor&reg;</strong> is a fully customizable surveillance service that provides easy
      access to
      critical
      material event information on U.S. municipal securities on an intra-day basis. The service provides timely
      access to
      vital event information allowing users to:
    </p>

    <ul>
      <li>Closely monitoring market activity that may affect the credit profile of a bond;</li>
      <li>Obtaining reliable alerts of new evidence of bond distress, so that you can protect your customers or your
        portfolio;
      </li>
      <li>Mitigating compliance risk with MSRB Rules G-17, G-19 and G-30 by ensuring timely access to critical event
        data
        as soon as it is available.
      </li>
    </ul>

    <p>
      <strong><i>Muni</i>GUARD&reg; News</strong> delivers "news in context" for municipal market professionals.
      Filtering thousands of
      stories
      daily from more than 500 largely local and regional news sources, <i>Muni</i>GUARD News searches for linkages to
      any
      of the
      entire range of active CUSIPS in the municipal securities market. It delivers the results in seamless
      integration
      with users' workflow and links news stories based on our Relevancy Index at the CUSIP/Series, Obligor, Location
      and/or Bond Type level.
    </p>

    <p>
      <strong>Filings Summary</strong> allows users to create a complete filing report of municipal disclosure for an
      obligor / issuer to assist in the due diligence process.
      These reports contain all filings related at the obligor / issuer level along with the filing date, document
      types and names, and a link back to the filing,
      as well as access to the MuniGUARD&reg; News data set. These reports can then be printed, downloaded as a PDF,
      or emailed.
    </p>

  </div>
</mat-dialog-content>
